import { h, render, Component } from 'preact';
import SharedFiltersStore from './store/SharedFiltersStore';
import { observer } from 'mobx-react';


export default observer(
    class FilterItemChoice extends Component {
        constructor(props) {
            super(props);
        }

        handleChange = e => {
            const { target } = e;
            SharedFiltersStore.saveFilterPropertyStatus(target.name, target.value, target.checked);

            if(this.list && typeof(this.props.onChange) === 'function') {
                const selectedInput = this.list.querySelectorAll(`input[type="checkbox"][name="${this.props.id}"]:checked`);

                let values = [];

                if(selectedInput.length) {
                    values = Array.prototype.slice.call(selectedInput, 0).map(input => input.value)
                }

                this.props.onChange(this.props.id, values)
            }
        }

        bindListRef = list => {
            this.list = list;
        }

        render() {
            const props = this.props

            if(props.choices.length) {
                return (
                    <fieldset class="catalogue__filter__group">
                        <legend class="catalogue__filter__group__title">
                            { props.title }
                        </legend>
                        <ul ref={this.bindListRef} class="catalogue__filter__options">
                            {
                                props.choices.map(choice => (
                                    <li class="catalogue__filter__options__item">
                                        <label class="catalogue__filter__options__label">
                                            { choice.title }
                                            <input
                                                type="checkbox"
                                                name={props.id}
                                                value={choice.valueId}
                                                onChange={this.handleChange}
                                                {...(props.sharedState ? { checked: props.sharedState[choice.valueId] } : {})}
                                            />
                                            <span class="checkbox catalogue__filter__options__checkbox">
                                            </span>
                                        </label>
                                    </li>
                                ))
                            }
                        </ul>
                    </fieldset>
                )
            }

            return null;
        }
    }
);